<template>
  <div class="container base-height">
      <div class="columns base-height">
          <div class="column is-half base-height py-0">
              <div class="is-flex is-flex-direction-column base-height">
                  <div style="max-width:calc(100vw / 4);min-width: 320px;" class="box-logo">
                      <img :src="logoSrc" alt="logo" />
                  </div>
                  <div class="box-texto is-flex is-flex-direction-column is-justify-content-center is-flex-grow-1" style="margin-top:-4rem">
                      <div v-html="tituloDeErro"></div>
                      <hr class="mt-3 mb-4" />
                      <div v-html="mensagemDeErro"></div>
                  </div>
              </div>
          </div>
          <div class="column is-half py-0">
              <div class="is-flex base-height is-justify-content-center is-align-items-center">
                  <img :src="urlImagem" alt="Imagem" />
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  nmae: 'TrfPaginaErro',
  components: {
  },
  props: {
    mensagemDeErro: String,
    tituloDeErro: {
      type: String,
      default: `<h1 class="is-size-3">Ops!! Algo deu errado.</h1>`
    },
    urlImagem: {
      type: String,
      default: "https://cdn.alterdata.com.br/pack/econtador/interno/imgs/imagem-tela-erro.jpg"
    },
  },
  computed: {
    logoSrc() {
      return getComputedStyle(document.documentElement).getPropertyValue('--logoUrl').trim();
    }
  }
};
</script>

<style lang="scss" scoped>
.base-height {
    min-height: calc(100vh - 128px)
}
@media screen and (max-width: 768px) {
    .container {
        padding: 0 1rem;
    }
    .base-height {
        min-height: auto;
    }
    .box-texto {
        margin-top: 0!important;
        text-align: center
    } 
    .box-logo {
      text-align: center;
      max-width: none!important;
      img {
        max-width:320px;
        width:100%;
      }
    }
}
#erro-view-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;

  img {
    max-width: 640px;
  }
}

#logo-container {
  @media screen and (max-width: 900px) {
    display: flex;
    justify-content: center;
  }
  img {
    height: 95px;
  }
}
</style>
